import React, { useState } from 'react';

import { clsx } from 'clsx';

import FadeIn from 'src/components/elements/FadeIn';

import useIsWebview from 'src/hooks/useIsWebview';

import { Bubble } from './blocks/Bubble/Bubble';
import { bubbleData } from './blocks/Bubble/bubbleData';

import { motion } from 'framer-motion';

import styles from './Invite.scss';

const Invite = () => {
  const [activeCircle, setActiveCircle] = useState<{ x: number; y: number; radius: number } | null>(
    null
  );

  const isWebview = useIsWebview();

  return (
    <motion.div className={styles.rootContainer} id="invite-friends">
      <div className={styles.titleContainer}>
        <FadeIn className={styles.title}>Invite your friends</FadeIn>
        <FadeIn delay={1} className={styles.subtitle}>
          to join in
        </FadeIn>

        <FadeIn delay={1.5} className={styles.description}>
          By sharing this link on social media
          <br /> and messengers
        </FadeIn>
      </div>

      <div
        className={clsx(styles.linksContainer, {
          [styles.webview]: isWebview,
        })}
      >
        {bubbleData().map(
          (item) =>
            (!isWebview || item.webview) && (
              <Bubble
                x={item.x}
                y={item.y}
                radius={item.radius}
                icon={item.icon}
                bubbleClick={item.onClick}
                activeCircle={activeCircle}
                setActiveCircle={setActiveCircle}
                key={item.id}
              />
            )
        )}
      </div>
    </motion.div>
  );
};

export default Invite;
